/** @file This file defines **internal** parsers for the jupyter package. */
import { Right } from 'purify-ts';
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
/** The multiline parser used for Jupyter output. */
export const multilineString = parsers.mapParser(codec.oneOf([codec.string, codec.array(codec.string)]), (lines) => lines, (lines) => {
    const str = typeof lines === 'string' ? lines : lines.join('');
    // Jupyter notebook sources should not contain CRLF line endings, so
    // replace CRLF with LF just in case a notebook does contain CRLFs.
    return Right(str.replace(/\r\n/g, '\n'));
});
